var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("footer", [
    _c("div", { staticClass: "footerlogos" }, [
      _c("div", { staticClass: "footerlogo-left" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "footercontact" },
          [
            _vm._v(
              "\n                601 South Prospect Street, Galena, Illinois 61036, USA"
            ),
            _c("BR"),
            _vm._v(" "),
            _c("strong", [_vm._v("Tel:")]),
            _vm._v(" +1 815 777 4444\n                "),
            _c("strong", [_vm._v("E-mail:")]),
            _vm._v(" curatorial@chicagoathenaeum.org\n                "),
            _c("BR"),
            _vm._v(" "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.chi-athenaeum.org/",
                  target: "_blank",
                },
              },
              [_vm._v("chicagoathenaeum.org")]
            ),
            _vm._v("\n                |\n                "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.metropolitanartspress.com",
                  target: "_blank",
                },
              },
              [_vm._v("metropolitanartspress.com")]
            ),
            _vm._v("\n                |\n                "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.instagram.com/thechicagoathenaeummuseum/",
                  target: "_blank",
                },
              },
              [_vm._v("Instagram")]
            ),
            _vm._v("\n                |\n                "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.facebook.com/TheChicagoAthenaeumMuseum?ref=hlm",
                  target: "_blank",
                },
              },
              [_vm._v("Facebook")]
            ),
            _vm._v("\n                |\n                "),
            _c(
              "a",
              {
                attrs: {
                  href: "https://www.youtube.com/@thechicagoathenaeummuseum",
                  target: "_blank",
                },
              },
              [_vm._v("Youtube")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footerlogo-right" }, [_vm._t("default")], 2),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "a",
      { attrs: { href: "https://www.chi-athenaeum.org/", target: "_blank" } },
      [_c("img", { attrs: { src: "/images/TCA-LOGOTYPE.png" } })]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }